<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page

========================================================================================== -->

<template>
  <div id="page-user-view">
    <vs-alert v-if="errorOccurred" color="danger" title="Course Not Found">
      <span>Course record with id: not found. </span>
      <span>
        <span>Check </span><router-link :to="{ name: 'admin-list-courses' }" class="text-inherit underline">All Courses</router-link>
      </span>
    </vs-alert>

    <div v-if="courseData" id="course-data">
      <!--- TOP COURSE BANNER START --->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <div
            class="rounded-lg w-full"
            style="
              background-image: url(https://cdn.discordapp.com/attachments/733851758211629347/954057924391600218/BG.png);
              box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
            "
          >
            <div class="knowledge-base-jumbotron-content rounded-lg lg:p-12 sm:p-10 p-8" style="backdrop-filter: blur(10px)">
              <div class="flex justify-between items-center">
                <div>
                  <h5 class="font-light text-white ml-2">Course Admin</h5>
                  <h1 class="text-white font-bold" style="font-size: 4rem">{{ courseData.name }}</h1>
                </div>
                <img v-if="courseData.thumbnail" :src="courseData.thumbnail" class="rounded-lg" width="200px" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--- TOP COURSE BANNER END --->

      <!--- COURSE ACTION BAR START --->
      <div class="vx-row mb-6 match-height">
        <div class="vx-col grid grid-cols-3 gap-8 w-full">
          <vx-card
            class="p-6 cursor-pointer text-white"
            @click="addStudentSearchActive = true"
            :style="`background-image: linear-gradient(118deg, rgba(var(--vs-success), 0.4), rgba(var(--vs-success), .2)), url(${cardBgImgURL})`"
          >
            <div class="flex items-center justify-center">
              <feather-icon icon="UserPlusIcon" svgClasses="h-16 w-16" />
            </div>
            <div class="flex items-center justify-center">
              <h2 class="text-center mt-4 text-white">Assign<br />Student</h2>
            </div>
          </vx-card>
          <vx-card
            class="p-6 cursor-pointer text-white"
            @click="subscriptionsManagerPopup = !subscriptionsManagerPopup"
            :style="`background-image: linear-gradient(118deg, rgba(var(--vs-primary), 0.4), rgba(var(--vs-primary), .2)), url(${cardBgImgURL})`"
          >
            <div class="flex items-center justify-center">
              <feather-icon icon="CreditCardIcon" svgClasses="h-16 w-16" />
            </div>
            <div class="flex items-center justify-center">
              <h2 class="text-center mt-4 text-white">Subscriptions<br />Manager</h2>
            </div>
          </vx-card>
          <vx-card
            class="p-6 cursor-pointer text-white"
            @click="$router.push(`/a/courses/${courseData.id}/mass`)"
            :style="`background-image: linear-gradient(118deg, rgba(var(--vs-danger), 0.4), rgba(var(--vs-danger), .2)), url(${cardBgImgURL})`"
          >
            <div class="flex items-center justify-center">
              <feather-icon icon="FileTextIcon" svgClasses="h-16 w-16" />
            </div>
            <div class="flex items-center justify-center">
              <h2 class="text-center mt-4 text-white">Generate<br />Report</h2>
            </div>
          </vx-card>
        </div>
      </div>
      <!--- COURSE ACTION BAR END --->

      <!--- COURSE SHOW INFORMATION START--->
      <div class="vx-row mb-6 match-height">
        <div class="vx-col w-1/3">
          <vx-card class="w-full flex items-center">
            <h3 class="font-bold">Course Id</h3>
            <h3 class="font-light">{{ courseData.id }}</h3>
          </vx-card>
        </div>
        <div class="vx-col w-1/3">
          <vx-card class="w-full flex items-center">
            <h3 class="font-bold">Course Status</h3>
            <h3 class="capitalize font-light">{{ courseData.status | capitalize }}</h3>
          </vx-card>
        </div>
        <div class="vx-col w-1/3">
          <vx-card class="p-1">
            <div class="grid grid-cols-2 gap-4 w-">
              <vs-button @click="editCoursePopup = !editCoursePopup" class="w-full" icon="icon-edit" icon-pack="feather">Edit </vs-button>
              <vs-button class="w-full" color="danger" icon="icon-trash" icon-pack="feather" @click="confirmDeleteCourse"
                >Archive
              </vs-button>
            </div>
          </vx-card>
        </div>
      </div>
      <!--- COURSE SHOW INFORMATION END--->

      <!-- COURSE BUILDER START --->
      <div v-if="courseStructureExists">
        <div v-if="courseData && structureData">
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <vx-card>
                <div class="flex items-center justify-between">
                  <div class="flex items-center">
                    <img class="mr-4 rounded" :src="courseData.thumbnail" v-if="courseData.thumbnail" width="40" height="40" alt="" />
                    <h1 class="">Course Builder</h1>
                  </div>
                  <div class="flex justify-end items-center">
                    <feather-icon v-if="autoSave.status === 'success'" icon="CheckIcon" svgClasses="h-5 w-5 text-success mr-2" />
                    <div
                      v-else-if="autoSave.status === 'pending'"
                      class="vs-con-loading__container h-5 w-5 mr-2"
                      id="pendingLoadingCircle"
                    />
                    <feather-icon v-else icon="XCircleIcon" svgClasses="h-5 w-5 text-danger mr-2" />
                    <p class="cursor-pointer" @click="saveChanges">{{ autoSave.text }}</p>
                  </div>
                </div>
              </vx-card>
            </div>
          </div>

          <div class="border border-solid rounded-lg p-1 mb-6">
            <vs-collapse-item class="p-0">
              <div slot="header" class="p-0">
                <h3 class="font-light">Simulations</h3>
              </div>
              <div class="vx-row">
                <div class="vx-col w-2/3">
                  <vx-card>
                    <div>
                      <div class="p-6 rounded-lg overflow-y-scroll" style="background-color: rgba(0, 0, 0, 0.15)">
                        <div v-if="!isAuthorizedSimulationsEmpty || dragging === true">
                          <h1 class="my-6 font-bold text-center" v-if="isAuthorizedSimulationsEmpty && dragging === true">
                            Drop Simulation Here
                          </h1>
                          <draggable
                            class="grid grid-cols-4 gap-5 cursor-move"
                            :list="structureData.authorized_simulations"
                            :group="{ name: 'simulations' }"
                            @change="saveChanges"
                            style="min-height: 15rem"
                          >
                            <div
                              class="flex items-center justify-center cursor-move py-4"
                              v-for="(simulation, index) in structureData.authorized_simulations"
                              :key="index"
                            >
                              <div class="p-1">
                                <div class="flex justify-center">
                                  <img :src="simulation.thumbnail" width="110" class="rounded-lg" alt="" />
                                </div>
                                <h5 class="font-bold text-center mt-3">{{ simulation.name }}</h5>
                                <div class="flex items-center justify-center mt-3">
                                  <vs-button
                                    color="primary"
                                    type="gradient"
                                    size="small"
                                    icon-pack="feather"
                                    icon="icon-edit"
                                    style="min-width: 120px"
                                    @click="$router.push(`/a/simulations/${simulation.id}`)"
                                    >Edit
                                  </vs-button>
                                </div>
                                <div class="flex items-center justify-center mt-3">
                                  <vs-button
                                    color="danger"
                                    type="gradient"
                                    size="small"
                                    icon-pack="feather"
                                    icon="icon-trash"
                                    style="min-width: 120px"
                                    @click="removeSimulationFromStructureConfirm(index)"
                                    >Delete
                                  </vs-button>
                                </div>
                              </div>
                            </div>
                          </draggable>
                        </div>
                        <div v-if="isAuthorizedSimulationsEmpty && dragging === false">
                          <div class="flex items-center justify-center">
                            <lottie-animation
                              path="https://assets3.lottiefiles.com/packages/lf20_1iNByG.json"
                              :loop="true"
                              :autoPlay="true"
                              :speed="1"
                              :width="300"
                            />
                          </div>
                          <h1 class="font-bold text-center mt-4">Its Lonely In Here</h1>
                          <h5 class="text-light text-center mt-2 mb-4">To Add Simulations Drag Them Into This Box</h5>
                        </div>
                      </div>
                    </div>
                  </vx-card>
                </div>
                <div class="vx-col w-1/3">
                  <vx-card class="mb-base">
                    <h4>Simulations Bank</h4>
                    <vs-input
                      v-model="simulationsSearch"
                      @input="fetchSimulationsList"
                      class="my-4 mt-5 w-full"
                      placeholder="Search for Simulations"
                    />
                    <vs-list class="p-0 mt-3" v-if="simulationsList.length !== 0">
                      <draggable
                        :list="simulationsList"
                        :group="{ name: 'simulations', pull: 'clone', put: false }"
                        :sort="false"
                        :move="checkMoveSimulation"
                        class="cursor-move"
                        @start="dragging = true"
                        @end="dragging = false"
                      >
                        <vs-list-item v-for="listItem in simulationsList" :key="listItem.id" :title="listItem.name" :subtitle="listItem.id">
                          <vs-avatar slot="avatar" :src="listItem.thumbnail" class="mr-3" />
                        </vs-list-item>
                      </draggable>
                    </vs-list>
                    <p class="mt-2 p-1" v-else>No Records Found</p>
                  </vx-card>
                </div>
              </div>
            </vs-collapse-item>
          </div>

          <div class="border border-solid rounded-lg p-1 mb-6">
            <vs-collapse-item class="p-0">
              <div slot="header" class="p-0">
                <h3 class="font-light">Labs</h3>
              </div>
              <div class="vx-row">
                <div class="vx-col w-2/3">
                  <vx-card>
                    <div>
                      <div class="p-6 rounded-lg overflow-y-scroll" style="background-color: rgba(0, 0, 0, 0.15)">
                        <div v-if="!isAuthorizedLabsEmpty || dragging === true">
                          <h1 class="my-6 font-bold text-center" v-if="isAuthorizedLabsEmpty && dragging === true">Drop Lab Here</h1>
                          <draggable
                            class="grid grid-cols-4 gap-5 cursor-move"
                            :list="structureData.authorized_labs"
                            :group="{ name: 'labs' }"
                            @change="saveChanges"
                            style="min-height: 15rem"
                          >
                            <div
                              class="flex items-center justify-center cursor-move py-4"
                              v-for="(lab, index) in structureData.authorized_labs"
                              :key="index"
                            >
                              <div class="p-1">
                                <div class="flex justify-center">
                                  <img :src="lab.thumbnail" width="110" class="rounded-lg" alt="" />
                                </div>
                                <h5 class="font-bold text-center mt-3">{{ lab.name }}</h5>
                                <div class="flex items-center justify-center mt-3">
                                  <vs-button
                                    color="primary"
                                    type="gradient"
                                    size="small"
                                    icon-pack="feather"
                                    icon="icon-edit"
                                    style="min-width: 120px"
                                    @click="$router.push(`/a/labs/properties/${lab.id}`)"
                                    >Edit
                                  </vs-button>
                                </div>
                                <div class="flex items-center justify-center mt-3">
                                  <vs-button
                                    color="danger"
                                    type="gradient"
                                    size="small"
                                    icon-pack="feather"
                                    icon="icon-trash"
                                    style="min-width: 120px"
                                    @click="removeLabFromStructureConfirm(index)"
                                    >Delete
                                  </vs-button>
                                </div>
                              </div>
                            </div>
                          </draggable>
                        </div>
                        <div v-if="isAuthorizedLabsEmpty && dragging === false">
                          <div class="flex items-center justify-center">
                            <lottie-animation
                              path="https://assets3.lottiefiles.com/packages/lf20_1iNByG.json"
                              :loop="true"
                              :autoPlay="true"
                              :speed="1"
                              :width="300"
                            />
                          </div>
                          <h1 class="font-bold text-center mt-4">Its Lonely In Here</h1>
                          <h5 class="text-light text-center mt-2 mb-4">To Add Labs Drag Them Into This Box</h5>
                        </div>
                      </div>
                    </div>
                  </vx-card>
                </div>
                <div class="vx-col w-1/3">
                  <vx-card class="mb-base">
                    <h4>Labs Bank</h4>
                    <vs-input v-model="labsSearch" @input="fetchLabsList" class="my-4 mt-5 w-full" placeholder="Search for Labs" />
                    <vs-list class="p-0 mt-3" v-if="labsList.length !== 0">
                      <draggable
                        :list="labsList"
                        :group="{ name: 'labs', pull: 'clone', put: false }"
                        :sort="false"
                        :move="checkMoveLab"
                        class="cursor-move"
                        @start="dragging = true"
                        @end="dragging = false"
                      >
                        <vs-list-item v-for="listItem in labsList" :key="listItem.id" :title="listItem.name" :subtitle="listItem.id">
                          <vs-avatar slot="avatar" :src="listItem.thumbnail" class="mr-3" />
                        </vs-list-item>
                      </draggable>
                    </vs-list>
                    <p class="mt-2 p-1" v-else>No Records Found</p>
                  </vx-card>
                </div>
              </div>
            </vs-collapse-item>
          </div>

          <div class="border border-solid rounded-lg p-1 mb-6">
            <vs-collapse-item class="p-0">
              <div slot="header" class="p-0">
                <h3 class="font-light">FlashCard Domains</h3>
              </div>
              <div class="vx-row">
                <div class="vx-col w-2/3">
                  <vx-card>
                    <div>
                      <div class="mb-6 p-6 rounded-lg overflow-y-scroll" style="background-color: rgba(0, 0, 0, 0.15)">
                        <div v-if="!isAuthorizedFlashCardDomainsEmpty || dragging === true">
                          <h1 class="my-6 font-bold text-center" v-if="isAuthorizedFlashCardDomainsEmpty && dragging === true">
                            Drop Domain Here
                          </h1>
                          <draggable
                            class="grid grid-cols-3 gap-5 cursor-move"
                            :list="structureData.authorized_flashcard_domains"
                            :group="{ name: 'flashcard_domains' }"
                            @change="saveChanges"
                            style="min-height: 15rem"
                          >
                            <div
                              class="flex items-center justify-center cursor-move py-4"
                              v-for="(domain, index) in structureData.authorized_flashcard_domains"
                              :key="index"
                            >
                              <div class="p-1">
                                <div class="flex justify-center">
                                  <img :src="domain.thumbnail" width="110" class="rounded-lg" alt="" />
                                </div>
                                <h5 class="font-bold text-center mt-3">{{ domain.name }}</h5>
                                <div class="flex items-center justify-center mt-3">
                                  <vs-button
                                    color="primary"
                                    type="gradient"
                                    size="small"
                                    icon-pack="feather"
                                    icon="icon-edit"
                                    style="min-width: 120px"
                                    @click="$router.push(`/a/flashcards/domains/${domain.id}`)"
                                    >Edit
                                  </vs-button>
                                </div>
                                <div class="flex items-center justify-center mt-3">
                                  <vs-button
                                    color="danger"
                                    type="gradient"
                                    size="small"
                                    icon-pack="feather"
                                    icon="icon-trash"
                                    style="min-width: 120px"
                                    @click="removeFlashCardSetFromStructureConfirm(index)"
                                    >Delete
                                  </vs-button>
                                </div>
                              </div>
                            </div>
                          </draggable>
                        </div>
                        <div v-if="isAuthorizedFlashCardDomainsEmpty && dragging === false">
                          <div class="flex items-center justify-center">
                            <lottie-animation
                              path="https://assets3.lottiefiles.com/packages/lf20_1iNByG.json"
                              :loop="true"
                              :autoPlay="true"
                              :speed="1"
                              :width="300"
                            />
                          </div>
                          <h1 class="font-bold text-center mt-4">Its Lonely In Here</h1>
                          <h5 class="text-light text-center mt-2 mb-4">To Add FlashCard Domains Drag Them Into This Box</h5>
                        </div>
                      </div>
                    </div>
                  </vx-card>
                </div>
                <div class="vx-col w-1/3">
                  <vx-card class="mb-base">
                    <h4>FlashCard Domains Bank</h4>
                    <vs-input
                      v-model="flashcardDomainsSearch"
                      @input="fetchFlashCardDomainsList"
                      class="my-4 mt-5 w-full"
                      placeholder="Search for Domains"
                    />
                    <vs-list class="p-0 mt-3" v-if="flashcardDomainsList.length !== 0">
                      <draggable
                        :list="flashcardDomainsList"
                        :group="{ name: 'flashcard_domains', pull: 'clone', put: false }"
                        :sort="false"
                        :move="checkMoveFlashCardDomain"
                        class="cursor-move"
                        @start="dragging = true"
                        @end="dragging = false"
                      >
                        <vs-list-item
                          v-for="listItem in flashcardDomainsList"
                          :key="listItem.id"
                          :title="listItem.name"
                          :subtitle="listItem.id"
                        >
                          <vs-avatar slot="avatar" :src="listItem.thumbnail" class="mr-3" />
                        </vs-list-item>
                      </draggable>
                    </vs-list>
                    <p class="mt-2 p-1" v-else>No Records Found</p>
                  </vx-card>
                </div>
              </div>
            </vs-collapse-item>
          </div>

          <div class="border border-solid rounded-lg p-1 mb-6">
            <vs-collapse-item class="p-0">
              <div slot="header" class="p-0">
                <h3 class="font-light">TestPrep Bank</h3>
              </div>
              <div class="vx-row">
                <div class="vx-col w-full">
                  <vx-card>
                    <div>
                      <p>Bank Id</p>
                      <vs-input
                        v-model="structureData.authorized_testprep_bank"
                        @input="saveChanges()"
                        class="w-1/3"
                        placeholder="Bank ID"
                      />
                    </div>
                  </vx-card>
                </div>
              </div>
            </vs-collapse-item>
          </div>
        </div>
        <div class="simple-spinner" v-else>
          <span></span>
        </div>
      </div>

      <!-- COURSE BUILDER END --->

      <vs-popup :active.sync="addStudentSearchActive" title="Assign Course To User - Search User">
        <vs-table :data="addStudentSearchResults" :sst="true" max-items="5" search @search="addStudentUserSearch">
          <template slot="header">
            <h3 class="ml-4">Users</h3>
          </template>

          <template slot="thead">
            <vs-th>Name</vs-th>
            <vs-th>Email</vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr v-for="attach in data" :key="attach.id">
              <vs-td :data="`${attach.first_name} ${attach.last_name}`">
                {{ `${attach.first_name} ${attach.last_name}` }}
              </vs-td>

              <vs-td :data="attach.email">
                {{ attach.email }}
              </vs-td>

              <vs-td>
                <vs-button color="primary" size="small" type="border" @click="addStudentToCourseApps(attach)"> Assign </vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vs-popup>
      <vs-popup :active.sync="appSearchActive" title="Assign Course To User - Select Apps">
        <vs-table :data="appSearchResults" :sst="true" max-items="5" search @search="addStudentAppsSearch" class="mb-2">
          <template slot="header">
            <h3 class="ml-4">Search Apps</h3>
          </template>

          <template slot="thead">
            <vs-th>Id</vs-th>
            <vs-th>Name</vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr v-for="attach in data" :key="attach.id">
              <vs-td :data="attach.id">
                {{ attach.id }}
              </vs-td>

              <vs-td :data="`${attach.name}`">
                <div class="flex align-middle items-center">
                  <img :src="attach.icon" class="rounded mr-3" width="40px" />
                  {{ `${attach.name}` }}
                </div>
              </vs-td>

              <vs-td>
                <vs-button color="primary" size="small" type="border" @click="addStudentToCourseAssignApp(attach)"> Assign </vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <vs-divider />
        <vs-table :data="appsSelected" max-items="5" pagination class="mt-2">
          <template slot="header">
            <h3 class="ml-4 mt-4 mb-3">Assigned Apps</h3>
          </template>

          <template slot="thead">
            <vs-th>Id</vs-th>
            <vs-th>Name</vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr v-for="(attach, index) in data" :key="attach.id">
              <vs-td :data="attach.id">
                {{ attach.id }}
              </vs-td>

              <vs-td :data="`${attach.name}`">
                <div class="flex align-middle items-center">
                  <img :src="attach.icon" class="rounded mr-3" width="40px" />
                  {{ `${attach.name}` }}
                </div>
              </vs-td>

              <vs-td>
                <vs-button color="primary" size="small" type="border" @click="appsSelected.splice(index, 1)"> Remove </vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <vs-button color="primary" type="filled" class="mt-3" @click="addStudentToCourseCalendar">Next Step</vs-button>
      </vs-popup>
      <vs-popup :active.sync="addStudentExpiryActive" title="Assign Course To User - Select Dates">
        <div class="mb-4">
          <h6>Choose Subscription Expiry</h6>
          <datepicker
            v-model="addStudentAssignCourseCalendar"
            :inline="true"
            class="datepicker-popup-inline mt-4"
            placeholder="Select Date"
          ></datepicker>
          <ul class="flex mt-5">
            <li>
              <vs-radio v-model="addStudentAssignCourseDuration" class="mr-4" vs-value="1" @input="calculateCalendarDate"
                >1 Month
              </vs-radio>
            </li>
            <li>
              <vs-radio v-model="addStudentAssignCourseDuration" class="mr-4" vs-value="3" @input="calculateCalendarDate"
                >3 Months
              </vs-radio>
            </li>
            <li>
              <vs-radio v-model="addStudentAssignCourseDuration" class="mr-4" vs-value="6" @input="calculateCalendarDate"
                >6 Months
              </vs-radio>
            </li>
            <li>
              <vs-radio v-model="addStudentAssignCourseDuration" class="mr-4" vs-value="12" @input="calculateCalendarDate"
                >1 Year
              </vs-radio>
            </li>
          </ul>
        </div>
        <p v-if="addStudentAssignCourseCalendar === null" class="text-danger font-bold">You Must Choose A Subscription Duration</p>

        <vs-button
          v-if="addStudentAssignCourseCalendar"
          color="primary"
          type="filled"
          @click="addStudentToCourseEnroll(addStudentAssignUser)"
          >Assign Student
        </vs-button>
      </vs-popup>
      <vs-popup :active.sync="editCoursePopup" title="Edit Course">
        <div class="popup-input" v-if="courseData">
          <p class="mb-1 font-semibold">Name</p>
          <vs-input v-model="courseData.name" class="mb-3 w-full" />

          <p class="mb-1 font-semibold">Description</p>
          <vs-textarea v-model="courseData.description" height="100px" class="mb-3 w-full" />

          <p class="mb-1 font-semibold">Code</p>
          <vs-input v-model="courseData.code" class="mb-3 w-full" />

          <p class="mb-1 font-semibold">Thumbnail</p>
          <vs-input v-model="courseData.thumbnail" class="mb-3 w-full" />

          <p class="mb-1 font-semibold">Status</p>
          <div class="flex items-center mb-3">
            <vs-radio v-model="courseData.status" vs-name="courseStatus" vs-value="active" class="mr-4">Active </vs-radio>
            <vs-radio v-model="courseData.status" vs-name="courseStatus" vs-value="hidden" class="mr-4">Hidden </vs-radio>
            <vs-radio v-model="courseData.status" vs-name="courseStatus" vs-value="disabled" class="mr-4">Disabled </vs-radio>
          </div>
        </div>
      </vs-popup>
      <vs-popup :active.sync="subscriptionsManagerPopup" title="Subscriptions Manager" class="fs-h-auto" fullscreen>
        <list-subscriptions :course-id="courseId" :filter-courses="false" />
      </vs-popup>
    </div>
    <div class="simple-spinner" v-else>
      <span></span>
    </div>
  </div>
</template>

<script>
import Prism from 'vue-prism-component'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import draggable from 'vuedraggable'
import LottieAnimation from '../../../../../components/lottie/LottieAnimation'
import ListSubscriptions from '../../../../student/subscriptions/admin/subscription-list/ListSubscriptions'

export default {
  data () {
    return {
      courseId: null,
      courseData: null,
      courseStructureExists: true,
      structureData: null,

      editCoursePopup: false,
      subscriptionsManagerPopup: false,

      appsList: [],
      appsSearch: '',

      simulationsList: [],
      simulationsSearch: '',

      labsList: [],
      labsSearch: '',

      flashcardDomainsList: [],
      flashcardDomainsSearch: '',

      testprepDomainsList: [],
      testprepDomainsSearch: '',

      autoSave: {
        status: 'success',
        text: 'Ready To Save'
      },
      dragging: false,

      cardBgImgURL: 'https://media.discordapp.net/attachments/733851758211629347/954057924630700132/BG2.png?width=1352&height=676',

      addStudentSearchActive: false,
      addStudentExpiryActive: false,
      addStudentAppActive: false,
      addStudentSearchResults: [],
      addStudentAppResults: [],
      addStudentAssignUser: {},
      addStudentAssignApp: [],
      addStudentAssignCourseDuration: null,
      addStudentAssignCourseCalendar: null,

      appSearchActive: false,
      appSearchResults: [],
      appsSelected: [],

      statusOptions: ['active', 'hidden', 'disabled'],

      removeId: null,

      errorOccurred: false
    }
  },
  components: {
    draggable,
    Prism,
    vSelect,
    Datepicker,
    LottieAnimation,
    ListSubscriptions
  },
  computed: {
    isAppsEnabledEmpty () {
      return this.structureData.apps_enabled.length === 0
    },
    isAuthorizedSimulationsEmpty () {
      return this.structureData.authorized_simulations.length === 0
    },
    isAuthorizedFlashCardDomainsEmpty () {
      return this.structureData.authorized_flashcard_domains.length === 0
    },
    isAuthorizedTestPrepDomainsEmpty () {
      return this.structureData.authorized_testprep_domains.length === 0
    },
    isAuthorizedLabsEmpty () {
      return this.structureData.authorized_labs.length === 0
    }
  },
  methods: {
    addStudentAppsSearch (term) {
      this.$http.get(`platform/apps?search=${term}&amount=5`).then((response) => {
        if (response.data) {
          this.appSearchResults = response.data.data
        }
      })
    },
    addStudentUserSearch (term) {
      this.$http.get(`users?search=${term}&amount=5`).then((response) => {
        if (response.data) {
          this.addStudentSearchResults = response.data.data
        }
      })
    },
    addStudentToCourseAssignApp (app) {
      let addApp = true
      this.appsSelected.forEach((item) => {
        if (item.id === app.id) {
          addApp = false
          return false
        }
      })

      if (addApp === true) {
        this.appsSelected.push(app)
      } else {
        this.$vs.notify({
          title: 'App Already Assigned',
          text: 'The app you tried to assign has already been assigned',
          color: 'danger',
          iconPack: 'feather',
          position: 'bottom-right',
          icon: 'icon-alert-circle'
        })
      }
    },
    addStudentToCourseApps (user) {
      this.addStudentSearchActive = false
      this.appSearchActive = true
      this.addStudentAssignUser = user
      this.addStudentAssignUser.profile_picture =
        this.addStudentAssignUser.profile_picture !== null ? this.addStudentAssignUser.profile_picture : 'default'
    },
    addStudentToCourseCalendar () {
      this.appSearchActive = false
      this.addStudentExpiryActive = true
    },
    addStudentToCourseEnroll (user) {
      this.$vs.loading()

      if (!this.addStudentAssignCourseCalendar) {
        this.$vs.notify({
          color: 'danger',
          title: 'Failed to create Subscription',
          text: 'Please provide subscription duration.',
          icon: 'feather',
          iconPack: 'icon-x-circle',
          position: 'top-right'
        })
        return this.$vs.loading.close()
      }

      const apps = []
      this.appsSelected.forEach((app) => {
        apps.push(app.id)
      })

      const pl = {
        assigner: JSON.parse(localStorage.getItem('userInfo')).id,
        user_id: user.id,
        course_id: this.courseData.id,
        status: 'active',
        apps
      }

      pl.ending_date = this.addStudentAssignCourseCalendar.getTime()

      this.$http
        .post('subscriptions/create', pl)
        .then((response) => {
          this.$vs.loading.close()

          if (response.status === 200) {
            return this.$vs.notify({
              color: 'success',
              title: 'Subscription Created',
              text: 'You have successfully created a subscription',
              icon: 'feather',
              iconPack: 'icon-check-circle',
              position: 'top-right'
            })
          }
        })
        .catch((exception) => {
          this.$vs.loading.close()
          return this.$vs.notify({
            color: 'danger',
            title: 'Failed to create Subscription',
            text: exception.response.data.error.description,
            icon: 'feather',
            iconPack: 'icon-x-circle',
            position: 'top-right'
          })
        })

      this.addStudentExpiryActive = false
      this.addStudentSearchActive = true
    },
    calculateCalendarDate () {
      const date = new Date()
      const months = parseInt(this.addStudentAssignCourseDuration)
      date.setMonth(date.getMonth() + months)
      this.addStudentAssignCourseCalendar = date
    },
    checkMoveLab (evt) {
      let move = true
      this.structureData.authorized_labs.forEach((lab) => {
        if (lab.id === evt.draggedContext.element.id) move = false
      })
      return move
    },
    checkMoveSimulation (evt) {
      let move = true
      this.structureData.authorized_simulations.forEach((simulation) => {
        if (simulation.id === evt.draggedContext.element.id) move = false
      })
      return move
    },
    checkMoveFlashCardDomain (evt) {
      let move = true
      this.structureData.authorized_flashcard_domains.forEach((domain) => {
        if (domain.id === evt.draggedContext.element.id) move = false
      })
      return move
    },
    checkMoveTestPrepDomain (evt) {
      let move = true
      this.structureData.authorized_testprep_domains.forEach((domain) => {
        if (domain.id === evt.draggedContext.element.id) move = false
      })
      return move
    },
    confirmDeleteCourse () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Archive',
        text: 'Please confirm you want to archive this courses.',
        accept: this.deleteCourse,
        acceptText: 'Archive'
      })
    },
    deleteCourse () {
      this.$vs.loading()

      this.$http
        .delete(`courses/${this.$route.params.courseId}`)
        .then((response) => {
          this.$vs.loading.close()

          if (response.status === 200) {
            this.$router.push('/a/courses')

            return this.$vs.notify({
              color: 'success',
              title: 'Course Archived',
              text: 'You have successfully archived this courses',
              icon: 'feather',
              iconPack: 'icon-check-circle',
              position: 'top-right'
            })
          }
        })
        .catch((exception) => {
          this.$vs.loading.close()

          let error = 'An unknown error occurred while deleting this courses.'
          if (exception.response) {
            error = exception.response.data.error.description
          }

          return this.$vs.notify({
            color: 'danger',
            title: 'Failed to Delete Group',
            text: error,
            icon: 'feather',
            iconPack: 'icon-x-circle',
            position: 'top-right'
          })
        })
    },
    fetchAppsList () {
      this.$http
        .get(`platform/apps?search=${this.appsSearch}&amount=5`)
        .then((response) => {
          if (response.status === 200) {
            this.appsList = response.data.data
          }
        })
        .catch(() => {})
    },
    fetchSimulationsList () {
      this.$http
        .get(`simulations?search=${this.simulationsSearch}&amount=5`)
        .then((response) => {
          if (response.status === 200) {
            this.simulationsList = response.data.data
          }
        })
        .catch(() => {})
    },
    fetchLabsList () {
      this.$http
        .get(`labs?search=${this.labsSearch}&amount=5`)
        .then((response) => {
          if (response.status === 200) {
            this.labsList = response.data.data
          }
        })
        .catch(() => {})
    },
    fetchFlashCardDomainsList () {
      this.$http
        .get(`flashcards/domains?search=${this.flashcardDomainsSearch}&amount=5`)
        .then((response) => {
          if (response.status === 200) {
            this.flashcardDomainsList = response.data.data
          }
        })
        .catch(() => {})
    },
    fetchTestPrepDomainsList () {
      this.$http
        .get(`testprep/domains?search=${this.flashcardDomainsSearch}&amount=5`)
        .then((response) => {
          if (response.status === 200) {
            this.testprepDomainsList = response.data.data
          }
        })
        .catch(() => {})
    },
    fetchInit () {
      const id = this.$route.params.courseId
      this.courseId = id
      this.fetchCourseDetails(id)
      this.fetchAppsList('')
      this.fetchSimulationsList('')
      this.fetchFlashCardDomainsList('')
      this.fetchTestPrepDomainsList('')
      this.fetchLabsList('')
      this.addStudentUserSearch('')
      this.addStudentAppsSearch('')
    },
    fetchCourseDetails (id) {
      this.$http
        .get(`courses/${id}`)
        .then((response) => {
          if (response.status === 200) {
            this.courseData = response.data.data
            if (!this.courseData.structure_id) this.courseStructureExists = true
            if (this.courseData.structure_id) this.fetchStructureDetails(response.data.data.structure_id)
          }
        })
        .catch((error) => {
          this.errorOccurred = true
          this.error_msg = error
        })
    },
    fetchStructureDetails (id) {
      this.$http
        .get(`structures/${id}?rich=true`)
        .then((response) => {
          if (response.status === 200) {
            this.structureData = response.data.data
          }
        })
        .catch((error) => {
          this.errorOccurred = true
          this.error_msg = error
        })
    },
    refreshCourseCache (id) {
      this.$vs.loading()

      this.$http
        .get(`courses/${id}/cache`)
        .then((response) => {
          this.$vs.loading.close()

          if (response.status === 200) {
            return this.$vs.notify({
              color: 'success',
              title: 'Cache Cleared',
              text: 'The courses cache has been cleared successfully',
              icon: 'feather',
              iconPack: 'icon-check-circle',
              position: 'top-right'
            })
          }
        })
        .catch(() => {
          this.$vs.loading.close()
          return this.$vs.notify({
            color: 'danger',
            title: 'Failed to Clear Cache',
            text: 'The courses cache was not cleared successfully',
            icon: 'feather',
            iconPack: 'icon-x-circle',
            position: 'top-right'
          })
        })
    },
    removeSimulationFromStructureConfirm (index) {
      this.removeId = index
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Remove Simulation From Course',
        text: 'Please confirm you want remove this simulation from the course.',
        accept: this.removeSimulationFromStructure,
        acceptText: 'Remove'
      })
    },
    removeSimulationFromStructure () {
      if (this.removeId === null) return
      this.structureData.authorized_simulations.splice(this.removeId, 1)
      this.saveChanges()
      this.removeId = null
    },
    removeLabFromStructureConfirm (index) {
      this.removeId = index
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Remove Lab From Course',
        text: 'Please confirm you want remove this lab from the course.',
        accept: this.removeLabFromStructure,
        acceptText: 'Remove'
      })
    },
    removeLabFromStructure () {
      if (this.removeId === null) return
      this.structureData.authorized_labs.splice(this.removeId, 1)
      this.saveChanges()
      this.removeId = null
    },
    removeFlashCardSetFromStructureConfirm (index) {
      this.removeId = index
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Remove Set From Course',
        text: 'Please confirm you want remove this set from the course.',
        accept: this.removeFlashCardSetFromStructure,
        acceptText: 'Remove'
      })
    },
    removeTestPrepSetFromStructure () {
      if (this.removeId === null) return
      this.structureData.authorized_testprep_domains.splice(this.removeId, 1)
      this.saveChanges()
      this.removeId = null
    },
    saveChanges () {
      const pl = {}
      for (const [key, value] of Object.entries(this.structureData)) {
        if (key === 'id') continue
        if (key === 'authorized_testprep_bank') {
          pl.authorized_testprep_bank = value
          continue
        }
        pl[key] = []
        value.forEach((item) => {
          pl[key].push(item.id)
        })
      }

      this.autoSave = {
        text: 'Saving...',
        status: 'pending'
      }

      setTimeout(() => {
        this.$vs.loading({
          color: '#FF9F43',
          background: 'transparent',
          container: '#pendingLoadingCircle',
          scale: 0.325,
          type: 'point'
        })
      }, 1)

      this.$http.post(`structures/${this.structureData.id}`, pl).catch(() => {
        this.$vs.loading.close('#pendingLoadingCircle> .con-vs-loading')
        this.autoSave = {
          text: 'Error While Saving Changes',
          status: 'error'
        }
      })

      setTimeout(() => {
        this.$vs.loading.close('#pendingLoadingCircle> .con-vs-loading')
        const date = new Intl.DateTimeFormat('en-US', {
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric'
        })
        this.autoSave = {
          text: `All Changes Saved - ${date.format(new Date())}`,
          status: 'success'
        }
      }, 1500)
    },
    updateCourse () {
      this.$http
        .post(`courses/${this.courseId}`, this.courseData)
        .then((response) => {
          if (response.status === 200) {
            this.$vs.notify({
              title: 'Course Updated Successfully',
              text: `${this.courseData.name} has been updated.`,
              color: 'success',
              position: 'bottom-right',
              iconPack: 'feather',
              icon: 'icon-check-circle'
            })
          }
        })
        .catch((exception) => {
          let error = 'An unknown error occurred while updating this Course'
          if (exception.response) {
            error = exception.response.data.error.description
          }
          this.$vs.notify({
            title: 'Failed To Update Course',
            text: error,
            color: 'danger',
            position: 'bottom-right',
            iconPack: 'feather',
            icon: 'icon-x-circle'
          })
        })
    }
  },
  created () {
    this.fetchInit()
  },
  watch: {
    editCoursePopup (val) {
      if (!val) this.updateCourse()
    }
  }
}
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }

  @media (min-width: 1200px) and (max-width: 1700px) {
    .image-course {
      display: none;
    }
    .course-col {
      width: 0 !important;
      min-height: 2.05vh;
    }
    .welcome-col {
      width: 100% !important;
    }
  }
}
</style>
